
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row, Button, Form, Input, Label, FormFeedback ,Spinner} from 'reactstrap';
import ParticlesAuth from "../ParticlesAuth";
import { useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';

//import images
import logoLight from "../../../assets/images/White Logo-1 1.png";
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const BasicTwosVerify = () => {
    document.title = "Whistlemind Demo Engine | Password Reset";

    const [passwordShow, setPasswordShow] = useState(false);
    const navigate = useNavigate()
    const location = useLocation();
    const { state } = location;
    const userName = state?.username;
    const [loading, setLoading] = useState(false);

    const [otp, setOtp] = useState(["", "", "", "", "", ""]); // State to store OTP digits

    const getInputElement = (index) => {
        return document.getElementById('digit' + index + '-input');
    }

   useEffect(()=>{
    if(!userName){
        navigate("/login")
    }
   })

    const moveToNext = (index) => {
        if (getInputElement(index).value.length === 1) {
            if (index !== 6) {
                getInputElement(index + 1).focus();
            } else {
                getInputElement(index).blur();
            }
        }
    }

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
    };
    const confirmationCode = otp.join("");

    const getCode = async () => {
        await resetPassword({ email: userName, username: userName })
    }

    const validation = useFormik({
        initialValues: {
            password: '',
            confirmPassword: ''
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(8, 'Password must be at least 8 characters')
                .matches(/.*[a-z].*/, 'At least one lowercase letter')
                .matches(/.*[A-Z].*/, 'At least one uppercase letter')
                .matches(/.*[0-9].*/, 'At least one number')
                .matches(/.*[!@#$%^&*?].*/, 'At least one special character')
                .required("This field is required"),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password')], 'Passwords must match')
                .required('Confirm password is required'),
        }),
        onSubmit: async (values) => {
            // submitData(values);
            setLoading(true)
            try {
                const res = await confirmResetPassword({ username: userName, confirmationCode, newPassword: values.password });

                toast.success("Password Set Successfuly")
                navigate('/login')

            } catch (error) {
                console.log(`error ${error.message}`);
                toast.error(`error ${error.message}`)

            }
            setLoading(false)
        }
    });

    document.title = "Beacon Eng. Chat Bot | Password Reset";
    return (
        <React.Fragment>
            <div className="auth-page-wrapper">
                <ParticlesAuth>
                    <div className="auth-page-content">
                        <Container>
                            <Row>
                                <Col lg={12}>
                                    <div className="text-center sm-5 mb-2 text-white-50">
                                        <div>
                                            <Link to="/dashboard" className="d-inline-block auth-logo">
                                                <img src={logoLight} alt="" height="59" />
                                            </Link>
                                        </div>
                                        
                                    </div>
                                </Col>
                            </Row>

                            <Row className="justify-content-center">
                                <Col md={8} lg={6} xl={5}>
                                    <Card className="mt-4">
                                        <CardBody className="p-4">
                                            
                                            <div className="p-2 ">
                                                <div className="text-muted text-center mb-4 mx-lg-3">
                                                    <h4 className="">Reset Password</h4>
                                                    <p>Please enter the 6 digit code sent to <span className="fw-semibold">{userName ? userName : "example@abc.com"}</span></p>
                                                </div>

                                                <Form>
                                                    <Row>
                                                        {[1, 2, 3, 4, 5, 6].map((index) => (
                                                            <Col className="col-2" key={index}>
                                                                <div className="mb-3">
                                                                    <Input
                                                                        type="text"
                                                                        className="form-control form-control-lg bg-light border-light text-center p-2"
                                                                        maxLength="1"
                                                                        id={`digit${index}-input`}
                                                                        onKeyUp={() => moveToNext(index)}
                                                                        onChange={(e) => handleOtpChange(index - 1, e.target.value)} // Store OTP digits
                                                                    />
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Form>

                                                <Form onSubmit={validation.handleSubmit}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="password" className="form-label">Password</Label>
                                                        <div className="position-relative auth-pass-inputgroup">
                                                            <Input
                                                                type={passwordShow ? "text" : "password"}
                                                                name="password"
                                                                className="form-control"
                                                                id="password"
                                                                placeholder="Enter new password"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.password}
                                                                invalid={validation.touched.password && validation.errors.password ? true : false}
                                                            />
                                                            {validation.touched.password && validation.errors.password ? (
                                                                <FormFeedback>{validation.errors.password}</FormFeedback>
                                                            ) : null}
                                                            <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" onClick={() => setPasswordShow(!passwordShow)} id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                                        </div>
                                                    </div>

                                                    <div className="mb-3">
                                                        <Label htmlFor="confirmPassword" className="form-label">Confirm Password</Label>
                                                        <Input
                                                            type="password"
                                                            name="confirmPassword"
                                                            className="form-control"
                                                            id="confirmPassword"
                                                            placeholder="Confirm your password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.confirmPassword}
                                                            invalid={validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false}
                                                        />
                                                        {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                                                            <FormFeedback>{validation.errors.confirmPassword}</FormFeedback>
                                                        ) : null}
                                                    </div>

                                                    <div className="text-center mt-3">
                                                        <Button disabled={loading} color="success" className="w-100" type="submit">{loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : "Confirm"}</Button>
                                                    </div>
                                                </Form>
                                            </div>
                                        </CardBody>
                                    </Card>

                                    <div className="mt-4 text-center">
                                        <p className="mb-0">Didn't receive a code? <Link onClick={getCode} to="#" className="fw-semibold text-primary text-decoration-underline">Resend</Link></p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </ParticlesAuth>
            </div>

        </React.Fragment>
    );
};

export default BasicTwosVerify;
